module.exports = __webpack_public_path__ + "img/papua-new-guinea.50b57a36.svg";